import { Outlet } from 'react-router-dom';

/** Full-bleed shell for auth pages — pages provide their own SignupShell. */
export function AuthLayout() {
  return <Outlet />;
}
